import styled from "styled-components"

import useMotibellMainList from "hooks/motibell/useMotibellMainList"

import MotibellItem from "./MotibellItem"

import Spinner from "components/modules/common/Spinner"

export default function MotibellList({ scrollRef }) {
  const { motibellItems, isLoading, isFetching, getMotibellStatus } = useMotibellMainList({
    scrollRef,
  })

  if (isLoading || !motibellItems) return null
  return (
    <ListBlock>
      {motibellItems.map((motibell) => (
        <MotibellItem
          key={`motibell-list-no-${motibell.no}`}
          motibellNo={motibell.no}
          status={getMotibellStatus({
            dueDate: motibell.due_date,
            endDate: motibell.end_date,
            currCapacity: motibell.curr_capacity,
            maxCapacity: motibell.max_capacity,
            isJoin: motibell.is_join,
          })}
          title={motibell.title}
          rewardTxt={motibell.reward_txt}
          currCapacity={motibell.curr_capacity}
          maxCapacity={motibell.max_capacity}
          viewCnt={motibell.view_cnt}
          isLanding={motibell.is_landing}
          isJoin={motibell.is_join}
        />
      ))}
      {isFetching && (
        <SpinnerBlock>
          <Spinner width={30} height={30} />
        </SpinnerBlock>
      )}
    </ListBlock>
  )
}

const ListBlock = styled.ul`
  display: flex;
  flex-direction: column;
  padding-bottom: calc(100vw * (50 / 375));
`

const SpinnerBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: calc(100vw * (16 / 375));
`
